import { IProduct } from "../types";

export function formatProductsToView(products: IProduct[]): IProduct[] {
  const formatedProducts = products.filter(item => item.showInBonification !== true).map(item => ({
    ...item,
    materialQuantity: 1
  }))

  return formatedProducts
}